import { ReactNode } from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { MdaSearchMode } from "./mda-types";

interface MdaModeChooserProps {
  onChoose: (mode: Exclude<MdaSearchMode, "choose">) => void;
}

interface ModeCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  onClick: () => void;
}

const ModeCard = ({ icon, title, description, onClick }: ModeCardProps) => (
  <Card
    variant="outlined"
    sx={{
      flex: 1,
      borderColor: "#dfe6f0",
      borderRadius: 1.5,
      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
      "&:hover": {
        borderColor: "#8bb2ff",
        boxShadow: "0 4px 14px rgba(23, 105, 255, 0.12)",
      },
    }}
  >
    {/* CardActionArea renders a button, so the card works from the keyboard too. */}
    <CardActionArea onClick={onClick} sx={{ height: "100%" }}>
      <CardContent sx={{ p: 3 }}>
        <Stack spacing={1.5}>
          <Box
            sx={{
              width: 48,
              height: 48,
              display: "grid",
              placeItems: "center",
              borderRadius: 1.5,
              backgroundColor: "#f3f7ff",
              color: "#1769ff",
            }}
          >
            {icon}
          </Box>
          <Typography
            component="h2"
            sx={{ color: "#12233f", fontSize: "1.1rem", fontWeight: 700 }}
          >
            {title}
          </Typography>
          <Typography sx={{ color: "#66758b", fontSize: "0.9rem" }}>
            {description}
          </Typography>
        </Stack>
      </CardContent>
    </CardActionArea>
  </Card>
);

const MdaModeChooser = ({ onChoose }: MdaModeChooserProps) => (
  <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 2, md: 3 }}>
    <ModeCard
      icon={<FilterAltOutlinedIcon />}
      title="Filter claims & export spreadsheet"
      description="Choose a client, filter its claims and request a spreadsheet of the ones you select."
      onClick={() => onChoose("filters")}
    />
    <ModeCard
      icon={<ManageSearchOutlinedIcon />}
      title="Search by claim reference"
      description="Find a single claim by its exact reference across all clients."
      onClick={() => onChoose("reference")}
    />
  </Stack>
);

export default MdaModeChooser;
